import React, {
  useState,
} from 'react';

import {
  Button,
  AddEntity,
} from 'web-components';

const SetNamespace = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button
        appearance="link"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Set namespace
      </Button>
      <AddEntity
        label="Set namespace"
        isOpen={isOpen}
        buttonLabel="Set"
        onRequestClose={() => {
          setIsOpen(false);
        }}
        onSubmit={(values, callbacks) => {
          window.localStorage.setItem('namespace', values.name);
          setTimeout(() => {
            callbacks.setSubmitting(false);
            window.location.reload();
          }, 600);
        }}
      />

    </>
  );
};

export default SetNamespace;
